module.exports = __webpack_public_path__ + "static/media/unify.01704a0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/unify.jpg
// module id = 354
// module chunks = 0